var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height",attrs:{"fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{staticClass:"text-center"},[_c('img',{attrs:{"src":require("@/assets/logo_light.png"),"alt":"Rubix"}}),_c('p',[_vm._v(" Coming Soon ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }